<script lang="ts">
  import type { CategoryPropConfig } from '../../modules/projects/project.interface';
  import { Checkbox } from 'svelte-materialify';
  import { LibraryList } from '../../lib/reader-list';
  import { onMount } from 'svelte';

  onMount(() => {
    fetchLibraryData();
  });

  export let values: string[] = [];
  export let categoryPropConfig: CategoryPropConfig;
  let selectedCategories = [...values];
  let categories = [];
  const libraryList = new LibraryList('/data/library.json');

  $: values = selectedCategories;

  async function fetchLibraryData() {
    const libraryCategories = await libraryList.getList();

    categories = libraryCategories;
  }
</script>

<div>
  {#if !categoryPropConfig.isOptional}
    <span>*</span>
  {/if}
  <span> {categoryPropConfig.name} </span>
  <div class="category-container justify-space-around col-sm-2">
    {#each categories as category}
      <Checkbox class="ma-2" bind:group={selectedCategories} value={category.name}
        >{category.name}</Checkbox
      >
    {/each}
  </div>
</div>

<style lang="scss">
  .category-container {
    border: 1px solid;
    border-color: green;
  }
</style>
